import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "12px 16px",
    borderBottom: "1px solid #d5d2d5",
    backgroundColor: "#f6f6f7"
  },

  titleLeft: {
    display: "flex",
    alignItems: "baseline",
    gap: "10px",
    minWidth: 0
  },

  titleText: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#4b1c46"
  },

  titleJobId: {
    fontSize: "13px",
    color: "#736973",
    fontFamily: "monospace"
  },

  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    padding: "48px 0"
  },

  dialogContent: {
    padding: "16px",
    // MUI zeroes padding-top on a DialogContent that follows a DialogTitle
    // (`.MuiDialogTitle-root + .MuiDialogContent-root`); that rule outranks a
    // single class, so restore it at matching specificity.
    "&.MuiDialogContent-root": {
      paddingTop: "16px"
    }
  },

  overviewGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "12px"
  },

  overviewField: {
    minWidth: 0
  },

  fieldLabel: {
    fontSize: "11px",
    color: "#8f8a8f",
    marginBottom: "2px"
  },

  fieldValue: {
    fontSize: "14px",
    color: "#333",
    wordBreak: "break-word"
  },

  divider: {
    margin: "18px 0 0"
  },

  tabs: {
    borderBottom: "1px solid #e5e2e5"
  },

  tab: {
    textTransform: "none",
    minWidth: 0,
    fontSize: "13px"
  },

  tabContent: {
    paddingTop: "16px"
  },

  failedReason: {
    marginBottom: "12px",
    fontSize: "14px",
    fontWeight: 500,
    color: "#d32f2f",
    wordBreak: "break-word"
  },

  codeBlock: {
    margin: 0,
    padding: "12px",
    maxHeight: 320,
    overflow: "auto",
    borderRadius: 4,
    border: "1px solid #e5e2e5",
    backgroundColor: "#fbfafb",
    fontSize: "12px",
    lineHeight: 1.5,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word"
  },

  flowNode: {
    paddingLeft: "20px",
    borderLeft: "1px solid #e5e2e5"
  },

  flowRow: {
    display: "flex",
    alignItems: "baseline",
    gap: "12px",
    padding: "6px 8px",
    fontSize: "13px"
  },

  flowCurrent: {
    display: "flex",
    alignItems: "baseline",
    gap: "12px",
    padding: "6px 8px",
    fontSize: "13px",
    borderRadius: 4,
    backgroundColor: "rgba(75, 28, 70, 0.08)"
  },

  flowName: {
    fontWeight: 500,
    color: "#4b1c46"
  },

  flowMeta: {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "#8f8a8f"
  },

  flowState: {
    marginLeft: "auto",
    padding: "1px 10px",
    borderRadius: "12px",
    fontSize: "12px",
    backgroundColor: "#f6f6f7",
    color: "#736973"
  },

  emptyText: {
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "italic",
    color: "#8f8a8f",
    padding: "32px 0"
  }
}));

export default useStyles;
